export default "__VITE_ASSET__ysdZgAeu__"